export default __webpack_public_path__ + "static/media/sticker-3.7664e981.png";